/* eslint-disable */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ws_response } from './ws/ws_response';
import { clearRedux } from '../redux/actions/adminAction';

const useWebSocket = (url, functions, accessToken) => {
  const Dispatch = useDispatch();

  useEffect(() => {
    if(accessToken !== "" && accessToken !== null ) {
      function connectWebSocket() {
          const socket = new WebSocket(url);
          functions(socket);
          // Set up event handlers
          socket.onmessage = function (evt) {
              Dispatch(ws_response({evt:evt, ws:socket }));
          };
          socket.onclose = (event) => {
              console.log("websocket close")
              // Reconnect after a delay
              if(localStorage.getItem("access_token") !== null) {
                setTimeout(() => {
                    console.log("Reconnecting...");
                    connectWebSocket();
                }, 1000); // Adjust the delay as needed
              } else {
                  Dispatch(clearRedux());
                  localStorage.clear();
                  localStorage.removeItem("access_token");
              }
          };
          return () => {
            socket.close();
          };
      };
      
      // Initial connection
      connectWebSocket();
    }
  }, [url]);
};

export default useWebSocket;